import { render } from "./ToCategoryBtn.vue?vue&type=template&id=c84a3de6"
import script from "./ToCategoryBtn.vue?vue&type=script&lang=js"
export * from "./ToCategoryBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__